export default __webpack_public_path__ + "static/media/1604372191-7792.0b555895.jpg";